module.exports = "/_next/static/resources/photo-4-e4353c6a2404fa67c5ef064e0ff4217a.webp";